<template>
  <div :class="['user-item', isEditing]">
    <div class="user-item__header">
      <p>{{ user.wallet }}</p>
      <p>{{ userConceptsLabel }}</p>
      <p>{{ userRoleHeader }}</p>
      <div>
        <button @click="toggleUserEdit">{{ userEditLabel }}</button>
      </div>
    </div>
    <div class="user-item__edit">
      <div class="user-item__edit-contents">
        <div class="user-edit-row align-top">
          <p>Concepts: {{ user.permissions }}</p>
          <div>
            <button v-if="user.permissions == 'all'" @click="setPermissions(user.id, 'some')">Change to Some</button>
            <button v-if="user.permissions == 'some'" @click="setPermissions(user.id, 'all')">Change to All</button>
            <UserConcepts :user="user" v-if="user.permissions == 'some'"></UserConcepts>
          </div>
        </div>
        <div class="user-edit-row">
          <p>Role: {{ userRole }}</p>
          <button v-if="user.role != 'Admin'" @click="makeAdmin(user.id)">Make Admin</button>
          <button v-if="user.role == 'Admin'" @click="revokeAdmin(user.id)">Revoke Admin</button>
        </div>
        <div class="user-edit-row">
          <p>Added: {{ userAddedDate }} ago</p>
          <button class="delete" @click="removeUserFromTrust(user.wallet, user.id)">Remove</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserConcepts from '@trust/components/UserConcepts.vue'

export default {
  name: 'UserSummary',
  components: {
    UserConcepts
  },
  props: ['user'],
  data() {
      return {
        editingUser: false,
      }
  },
  computed: {
    isEditing(){
      return this.editingUser ? 'is--editing' : '';
    },
    userEditLabel(){
      return this.editingUser ? 'Close' : 'Edit';
    },
    userRoleHeader(){
      return this.user.role == 'Admin' ? '👑 Admin' : '';
    },
    userRole(){
      return this.user.role == 'Admin' ? 'Admin' : 'User';
    },
    userAddedDate(){
      return this.timeSince(new Date(this.user.createdAt));
    },
    userConceptsLabel(){
      if(this.user.permissions == 'all'){
        return '👁 All Concepts';
      } else {
        return '👁 ' + this.user.concepts.length + ' Concepts';
      }
    }
  },
  mounted() {
  },
  methods: {
    toggleUserEdit(){
      this.editingUser = !this.editingUser;
    },
    removeUserFromTrust(userWallet, userId){
      if (confirm(`Select OK to remove ${userWallet} from ${this.$store.state.org.name}.`)) {
        // Confirmed
        this.$store.dispatch('removeUser', {userId});
      }
    },
    makeAdmin(userId){
      this.$store.dispatch('makeAdmin', {userId});
    },
    revokeAdmin(userId){
      this.$store.dispatch('revokeAdmin', {userId});
    },
    setPermissions(userId, permissions){
      this.$store.dispatch('setPermissions', {userId, permissions});
    },
    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " years";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    }
  },
}

</script>

<style>

.user-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  padding-right: 0;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-bottom: 1px solid var(--beige-500);
  transition: all 200ms ease-in-out;
}


.user-item__header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  width: 100%;
}

.user-item__header:last-child {
  text-align: right;
}

.user-item__edit {
  width: 100%;
  height: 0;
  overflow: hidden;
  pointer-events: none;
  width: 100%;
  transition: all 200ms ease-in-out;
}

.user-item__edit-contents {
  padding: 20px;
  padding-right: 0;
  width: 100%;
  box-sizing: border-box;
  transition: all 200ms ease-in-out;
}

.user-item.is--editing {
  border-left: 1px solid var(--beige-500);
  border-right: 1px solid var(--beige-500);
  background: var(--beige-200);
}

.user-item.is--editing .user-item__header {

}

.user-item.is--editing .user-item__edit {
  height: fit-content;
  pointer-events: all;
}

.user-edit-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  padding-right: 20px;
  border-bottom: 1px solid var(--beige-600);
}

.user-edit-row:last-child {
  border-bottom: none;
}

.user-edit-row.align-top {
  align-items: flex-start;
}

</style>
